import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=ec888668&scoped=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&id=ec888668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec888668",
  null
  
)

export default component.exports